import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface IdentityHistoricProblem {
    patientId: string;
    nomPrenom: string;
    raisons: RaisonEnum[];
}

export enum RaisonEnum {
    TooManyFieldsUpdatedAtOnce = "TOO_MANY_FIELDS_UPDATED_AT_ONCE",
    TooManyFieldsUpdatedSameDay = "TOO_MANY_FIELDS_UPDATED_SAME_DAY",
}

const RECHERCHE_ANOMALIE_IDENTITES_ENDPOINT = `${environment.basePath}/patient/checkIdentityHistoric`;

@Injectable({
  providedIn: 'root'
})
export class RechercheAnomaliesService {

  constructor(
    private _http: HttpClient,
  ) { }

  async rechercherAnomalies(): Promise<Array<IdentityHistoricProblem>> {
    try {
      const res = await this._http.get<Array<IdentityHistoricProblem>>(RECHERCHE_ANOMALIE_IDENTITES_ENDPOINT).toPromise();;
      return res;
    } catch (error) {
        console.error(error);
        throw error;
    }
  }
}
